import { useCallback, useEffect, useState } from 'react';

import {
  boardMemberOverview,
  boardMemberPortrait,
  boardStoreVisit,
} from '@/services/athenaBoard';

/**
 * 会员经营 · 容器级预取
 * ------------------------------------------------------------------
 * 从 MemberOps 容器里抽出来的原因：容器只该负责「拼装与导航」，
 * 取数逻辑收进 hook 后，容器从 600+ 行降到百行级（方案 P1-1）。
 *
 * 为什么这三块仍然在容器预取、而会员打卡/看得见活动各自取数：
 *   · 这三块的数据与筛选无关，且首屏就要看（概览/画像/行为各占一块）；
 *   · 那两块要按自身筛选与分页重新请求，放在各自 pane 里才能配合
 *     LazyMount —— 滚到视口才发请求（单页平铺后这是主要的性能对策）。
 */
export const useMemberOps = (params) => {
  const { tenantId, coachUserId } = params;

  const [overview, setOverview] = useState({});
  const [portrait, setPortrait] = useState({});
  const [visit, setVisit] = useState({});
  const [status, setStatus] = useState({
    overview: { loading: false, error: '' },
    portrait: { loading: false, error: '' },
    visit: { loading: false, error: '' },
  });

  const load = useCallback(() => {
    if (!tenantId || !coachUserId) {
      setOverview({});
      setPortrait({});
      setVisit({});
      setStatus({
        overview: { loading: false, error: '' },
        portrait: { loading: false, error: '' },
        visit: { loading: false, error: '' },
      });
      return;
    }
    setStatus({
      overview: { loading: true, error: '' },
      portrait: { loading: true, error: '' },
      visit: { loading: true, error: '' },
    });
    boardMemberOverview({ tenantId, coachUserId })
      .then((r) => {
        if (r && r.code === '00000') {
          setOverview(r.data || {});
          setStatus((current) => ({
            ...current,
            overview: { loading: false, error: '' },
          }));
        } else {
          throw new Error((r && r.msg) || '会员概览加载失败');
        }
      })
      .catch((error) => {
        setStatus((current) => ({
          ...current,
          overview: { loading: false, error: error.message },
        }));
      });

    boardMemberPortrait({ tenantId, coachUserId })
      .then((r) => {
        if (r && r.code === '00000') {
          setPortrait(r.data || {});
          setStatus((current) => ({
            ...current,
            portrait: { loading: false, error: '' },
          }));
        } else {
          throw new Error((r && r.msg) || '会员画像加载失败');
        }
      })
      .catch((error) => {
        setStatus((current) => ({
          ...current,
          portrait: { loading: false, error: error.message },
        }));
      });

    boardStoreVisit({ tenantId, coachUserId })
      .then((r) => {
        if (r && r.code === '00000') {
          setVisit(r.data || {});
          setStatus((current) => ({
            ...current,
            visit: { loading: false, error: '' },
          }));
        } else {
          throw new Error((r && r.msg) || '会员行为加载失败');
        }
      })
      .catch((error) => {
        setStatus((current) => ({
          ...current,
          visit: { loading: false, error: error.message },
        }));
      });
  }, [tenantId, coachUserId]);

  useEffect(() => {
    load();
  }, [load]);

  return { overview, portrait, visit, status, reload: load };
};

export default useMemberOps;
